import React, {useState, useEffect} from "react";

import type {SelectProps} from 'antd';
import { Select } from "antd";
import LedMachinePlatformApi from "../../api/LedMachinePlatformApi";
import type { LedMachinePlatform } from "../../type/LedMachinePlatformType";
import { ProFormSelectProps } from "@ant-design/pro-form/lib/components/Select";
import { ProFormSelect } from "@ant-design/pro-form";

const LedMachinePlatformSelector:React.FC<ProFormSelectProps> = (props)=>{

    const [options, setOptions] = useState<[]>([]);

    useEffect(()=>{
        LedMachinePlatformApi.findLedMachinePlatformList({
            limit: 100,
            deletedFlag: false,
        }).then((result:any)=>{
            const newOptions = result.map((ledMachinePlatform:LedMachinePlatform)=>{
                return {
                    key: ledMachinePlatform.id,
                    value: ledMachinePlatform.id,
                    label: ledMachinePlatform.name,
                };
            });

            setOptions(newOptions);
        });
    }, []);

    return (
        <ProFormSelect
            options={options}
            {...props}
        />
    );
};

export default LedMachinePlatformSelector;